// extracted by mini-css-extract-plugin
module.exports = {"container":"BuyLoadProductEmptyState_container__2o-Dm","link":"BuyLoadProductEmptyState_link__1qqJ6"};